import { Link } from "react-router-dom";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_college-genie-1/artifacts/yzns55kw_SM%20Logo%201080x1080%20Clear%20background.png";

export const Logo = () => {
  return (
    <Link
      to="/"
      data-testid="brand-logo"
      className="flex items-center gap-3 select-none group"
      aria-label="Scholar Mosaic, Your Unique College Blueprint"
    >
      <img
        src={LOGO_URL}
        alt="Scholar Mosaic logo"
        className="h-32 md:h-44 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]"
        loading="eager"
      />
    </Link>
  );
};

// Text-only inverse variant for dark sections (footer)
export const LogoText = ({ tagline = true }) => (
  <div className="flex flex-col gap-1 leading-none" data-testid="brand-logo-text">
    <span className="font-serif text-[#FBF9F6] text-3xl md:text-4xl font-black tracking-tight">
      Scholar<span className="text-orange-500">.</span> <span className="italic font-medium text-yellow-400">Mosaic</span>
    </span>
    {tagline && (
      <span className="text-xs uppercase tracking-[0.28em] font-bold text-[#FBF9F6]/65 mt-2">
        Your Unique College Blueprint
      </span>
    )}
  </div>
);

export default Logo;
